<template>
  <div class="zone-import-simulator">
    <div class="flex mb2 input">
      <input type="text" v-model="input" v-on:keyup.enter="query" class="pv2 ph3" placeholder="howhttps.works" />
      <button type="button" v-on:click="query" class="pa3">Try Me</button>
    </div>
    <div class="records">
      <div v-if="records.length > 0">
        <table>
          <thead>
            <th class="ph3 pv2">Type</th>
            <th>Name</th>
            <th>Content</th>
          </thead>
          <tbody>
            <tr v-for="record in sortedRecords" :key="record.id">
              <td class="ttu pa3"><strong>{{ record.type }}</strong></td>
              <td>{{ fqn(record) }}</td>
              <td class="text-break">{{ record.content }}</td>
            </tr>
          </tbody>
        </table>
        <p class="pa3 text-xs text-subtle">You can enter a list of subdomains in the app. This is just a demo <span class="emoji">😎</span></p>
      </div>
      <div v-else-if="isSearching" class="pa3 text-centered">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="42" height="42" fill="gray"><circle transform="translate(8 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle><circle transform="translate(16 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle><circle transform="translate(24 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle></svg>
      </div>
      <div v-else-if="isDomainNotFound" class="pa3">
        <span class="emoji">😮</span> Does this domain exist? We couldn't find any DNS records. Please check the domain name and try again.
      </div>
      <div v-else-if="noRecords" class="pa3">
        It seems that this domain has no DNS records that we can scan at the moment <span class="emoji">🤔</span>
      </div>
      <div v-else-if="noInput" class="pa3">
        Type the name of your domain above.
      </div>
      <div v-else-if="readyToImport" class="pa3">
        Click "Try me" to import the DNS records. <span class="emoji">☝️</span>
      </div>
    </div>
  </div>
</template>

<script>
import { SORT_BY_TYPE } from '../../javascript/common/sorters.js';
import ajax from '../../javascript/common/ajax.js';
import buildRecords from '../import-dns/build-records.js';

export default {
  props: ['urlZonevision'],
  data () {
    return {
      input: 'howhttps.works',
      records: [],
      isDomainNotFound: false,
      isDone: false,
      isSearching: false
    };
  },
  watch: {
    input (text) {
      this.records = [];
      this.isDomainNotFound = false;
      this.isDone = false;
    }
  },
  methods: {
    query () {
      if (this.input.length === 0)
        return;

      this.isSearching = true;
      this.isDone = false;
      this.records = [];
      this.isDomainNotFound = false;

      const promises = ['', 'www', 'blog', 'email'].map(this.fetchDNS);

      return Promise.all(promises)
        .finally(() => {
          this.isDone = true;
          this.isSearching = false;
        });
    },
    fetchDNS (subdomain) {
      const hostname = subdomain ? `${subdomain}.${this.input}` : this.input;

      return ajax(`${this.urlZonevision}/query/${hostname}`)
        .then((response) => {
          const records = buildRecords(response, subdomain);

          this.records.push(...records);
        })
        .catch(() => {
          if (!subdomain)
            this.isDomainNotFound = true;
        });
    },
    fqn (record) {
      return record.name ? `${record.name}.${this.input}` : this.input;
    }
  },
  computed: {
    noInput () {
      return this.input.length === 0;
    },
    noRecords () {
      return this.records.length === 0 && this.isDone && this.input.length > 0;
    },
    readyToImport () {
      return this.input.length > 0;
    },
    sortedRecords () {
      return this.records.slice(0).sort(SORT_BY_TYPE);
    }
  }
};
</script>
